//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InspectionTemplateItemDrawer from "./modules/InspectionTemplateItemDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: "InspectionTemplateItemList",
  mixins: [JeecgListMixin],
  components: {
    InspectionTemplateItemDrawer: InspectionTemplateItemDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/inspection/template/item',
      pageTitle: '巡检内容',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'pointId',
        colName: 'point_id',
        title: '模板点位id',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '检查内容名称',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'category',
        colName: 'category',
        title: '输入类型：1=是否（开关）;2=有无（开关）;8=数字输入;9=文本输入;',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'defaultValue',
        colName: 'default_value',
        title: '值：默认是、默认否',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '状态',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'delFlag',
        colName: 'del_flag',
        title: '删除状态',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序号',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};